import { useNavigate } from "react-router-dom";

import { ErrorDisplay } from "components/error-display";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <ErrorDisplay
      actions={[
        {
          label: "Back to Login",
          onClick: () => navigate("/"),
          variant: "orange",
        },
      ]}
      description="The page you're looking for doesn't exist or has been moved."
      errorCode="404"
      title="Page Not Found"
    />
  );
}
